import axios from "axios";
import {
  GET_LIVE_STREAMS,
  GET_STREAM,
  STREAM_NOT_LIVE,
  GET_MODERATORS,
  MAKE_MODERATOR,
  UPDATE_MODERATOR,
  REMOVE_MODERATOR,
  MODERATOR_ERROR,
  SEND_MESSAGE,
  SEND_MOD_MESSAGE,
  DELETE_CHAT_MESSAGE,
  DELETE_MODCHAT_MESSAGE,
  GET_TIMED_OUT_USERS,
  GET_BANNED_USERS,
  TIMEOUT_USER,
  UNTIMEOUT_USER,
  STREAM_ERROR,
  GET_SUPPORTERS,
  ADD_SUPPORTER,
  DELETE_SUPPORTER,
  SUPPORTER_ERROR,
  BAN_ERROR,
  UNBAN_USER,
  BAN_USER,
} from "./types";

// Get online streams
export const getOnlineStreams = () => async (dispatch) => {
  try {
    const res = await axios.get(`/api/stream`);

    dispatch({
      type: GET_LIVE_STREAMS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: STREAM_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const streamLive = () => (dispatch) => {
  dispatch({ type: GET_STREAM });
};

export const streamNotLive = () => (dispatch) => {
  dispatch({ type: STREAM_NOT_LIVE });
};

// Get timed out users
export const getTimedOutUsers = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/timedout`, formData, config);

    dispatch({
      type: GET_TIMED_OUT_USERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: STREAM_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get banned users
export const getBannedUsers = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/banned`, formData, config);

    dispatch({
      type: GET_BANNED_USERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: STREAM_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get moderators
export const getModerators = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/moderators`, formData, config);

    dispatch({
      type: GET_MODERATORS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MODERATOR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Make moderator
export const moderate = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/moderate`, formData, config);

    dispatch({
      type: MAKE_MODERATOR,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MODERATOR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Promote moderator
export const promoteModerator = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/promote`, formData, config);

    dispatch({
      type: UPDATE_MODERATOR,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MODERATOR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Demote moderator
export const demoteModerator = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/demote`, formData, config);

    dispatch({
      type: UPDATE_MODERATOR,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MODERATOR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Remove moderator
export const deleteModerator = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/stream/delete_moderator`,
      formData,
      config,
    );

    dispatch({
      type: REMOVE_MODERATOR,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MODERATOR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Ban user from community
export const banUserCommunity =
  (
    postId,
    channelid,
    profile_channelid,
    text,
    isCurrent,
    description,
    video,
    image,
    gif,
  ) =>
  async (dispatch) => {
    const formData = new FormData();

    formData.append("postId", JSON.stringify(postId));
    formData.append("channelid", JSON.stringify(channelid));
    formData.append("profile_channelid", JSON.stringify(profile_channelid));
    formData.append("text", JSON.stringify(text));
    formData.append("isCurrent", JSON.stringify(isCurrent));
    formData.append("description", JSON.stringify(description));
    formData.append("video", JSON.stringify(video));
    formData.append("image", JSON.stringify(image));
    formData.append("gif", JSON.stringify(gif));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(
        `/api/stream/ban_community`,
        formData,
        config,
      );

      dispatch({
        type: BAN_USER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: BAN_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Ban user from community and delete comment
export const banUserCommunityComment =
  (
    postId,
    commentId,
    channelid,
    profile_channelid,
    text,
    isCurrent,
    description,
    gif,
  ) =>
  async (dispatch) => {
    const formData = new FormData();

    formData.append("postId", JSON.stringify(postId));
    formData.append("commentId", JSON.stringify(commentId));
    formData.append("channelid", JSON.stringify(channelid));
    formData.append("profile_channelid", JSON.stringify(profile_channelid));
    formData.append("text", JSON.stringify(text));
    formData.append("isCurrent", JSON.stringify(isCurrent));
    formData.append("description", JSON.stringify(description));
    formData.append("gif", JSON.stringify(gif));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(
        `/api/stream/ban_community_comment`,
        formData,
        config,
      );

      dispatch({
        type: BAN_USER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: BAN_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Ban user from community and delete reply
export const banUserCommunityReply =
  (
    commentId,
    replyId,
    channelid,
    profile_channelid,
    text,
    isCurrent,
    description,
    gif,
  ) =>
  async (dispatch) => {
    const formData = new FormData();

    formData.append("commentId", JSON.stringify(commentId));
    formData.append("replyId", JSON.stringify(replyId));
    formData.append("channelid", JSON.stringify(channelid));
    formData.append("profile_channelid", JSON.stringify(profile_channelid));
    formData.append("text", JSON.stringify(text));
    formData.append("isCurrent", JSON.stringify(isCurrent));
    formData.append("description", JSON.stringify(description));
    formData.append("gif", JSON.stringify(gif));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(
        `/api/stream/ban_community_comment`,
        formData,
        config,
      );

      dispatch({
        type: BAN_USER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: BAN_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Create a new message
export const chatMessage =
  (channelid, message, foundGif) => async (dispatch) => {
    const formData = new FormData();

    formData.append("message", JSON.stringify(message));

    formData.append("gif", JSON.stringify(foundGif));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(
        `/api/socketio/${channelid}/chat_message`,
        formData,
        config,
      );

      dispatch({
        type: SEND_MESSAGE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: STREAM_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Save a deleted chat message
export const deleteChatMessage = (channelid, message) => async (dispatch) => {
  const formData = new FormData();

  formData.append("message", JSON.stringify(message));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/stream/${channelid}/delete_chat_message`,
      formData,
      config,
    );

    dispatch({
      type: DELETE_CHAT_MESSAGE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: STREAM_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Save a deleted chat message
export const deleteModChatMessage =
  (channelid, message) => async (dispatch) => {
    const formData = new FormData();

    formData.append("message", JSON.stringify(message));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(
        `/api/stream/${channelid}/delete_modchat_message`,
        formData,
        config,
      );

      dispatch({
        type: DELETE_MODCHAT_MESSAGE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: STREAM_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Create a modchat new message
export const modChatMessage =
  (channelid, message, foundGif) => async (dispatch) => {
    const formData = new FormData();

    formData.append("channelid", JSON.stringify(channelid));

    formData.append("message", JSON.stringify(message));

    formData.append("gif", JSON.stringify(foundGif));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(
        `/api/socketio/${channelid}/modchat_message`,
        formData,
        config,
      );

      dispatch({
        type: SEND_MOD_MESSAGE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: STREAM_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Create a new message
export const jobChatMessage = (channelid, message) => async (dispatch) => {
  const formData = new FormData();

  formData.append("message", JSON.stringify(message));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/stream/${channelid}/job_chat_message`,
      formData,
      config,
    );

    dispatch({
      type: SEND_MESSAGE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: STREAM_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Timeout a user
export const timeoutUser = (message, profile) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(message));
  formData.append("profile_channelid", JSON.stringify(profile));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/timeout`, formData, config);

    dispatch({
      type: TIMEOUT_USER,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: STREAM_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// UnTimeout a user
export const unTimeoutUser = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/untimeout`, formData, config);

    dispatch({
      type: UNTIMEOUT_USER,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: STREAM_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Ban a user
export const banUser =
  (
    channelid,
    profile_id,
    text,
    isCurrent,
    description,
    video,
    image,
    gif,
    message,
  ) =>
  async (dispatch) => {
    const formData = new FormData();

    formData.append("channelid", JSON.stringify(channelid));
    formData.append("profile_channelid", JSON.stringify(profile_id));
    formData.append("text", JSON.stringify(text));
    formData.append("isCurrent", JSON.stringify(isCurrent));
    formData.append("description", JSON.stringify(description));
    formData.append("video", JSON.stringify(video));
    formData.append("image", JSON.stringify(image));
    formData.append("gif", JSON.stringify(gif));
    formData.append("message", JSON.stringify(message));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(`/api/stream/ban`, formData, config);

      dispatch({
        type: BAN_USER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: BAN_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// UnTimeout a user
export const unBanUser = (channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/stream/unban`, formData, config);

    dispatch({
      type: UNBAN_USER,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: BAN_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get supporters
export const getSupporters = () => async (dispatch) => {
  try {
    const res = await axios.get(`/api/stream/supporters`);

    dispatch({
      type: GET_SUPPORTERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUPPORTER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add a supporter
export const addSupporter = (supporter) => async (dispatch) => {
  const formData = new FormData();

  formData.append("supporter", JSON.stringify(supporter));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/socketio/supporter`, formData, config);

    dispatch({
      type: ADD_SUPPORTER,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUPPORTER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete a supporter
export const deleteSupporter = (id) => async (dispatch) => {
  const formData = new FormData();

  formData.append("id", JSON.stringify(id));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/stream/delete_supporter`,
      formData,
      config,
    );

    dispatch({
      type: DELETE_SUPPORTER,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUPPORTER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
